
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import Select from "./Select.vue";
import { formMixin, formOptionsMixin, formValidationMixin } from "../mixins";
import { getModule } from "vuex-module-decorators";
import SystemModule from "@/store/modules/system";

const systemModule = getModule(SystemModule);

@Component({
  components: {
    Select
  }
})
export default class AgentCommoditySelect extends Mixins(
  formMixin,
  formOptionsMixin,
  formValidationMixin
) {
  localCommodities: Array<any> = [];

  @Prop({ default: null })
  public billTo: string;

  @Prop({ default: () => null })
  public commodities: any[];

  @Prop({ default: false })
  public preload: true;

  @Prop({ default: 0 })
  public deliveryForId: number;

  @Watch("deliveryForId")
  @Watch("billTo")
  async billToChanged() {
    let payload = {
      code: "",
      billTo: this.billTo,
      deliveryForId: this.deliveryForId ?? 0
    };

    let results = await systemModule.searchCommoditiesByCode(payload);
    this.$data.localCommodities = results.map(x => ({ label: x.agentId, value: x.code }));
  }

  async search(value, loading) {
    if (this.commodities) return;

    loading(true);
    let payload = {
      code: value,
      billTo: this.billTo,
      deliveryForId: this.deliveryForId
    };
    try {
      let results = await systemModule.searchCommoditiesByCode(payload);
      this.$data.localCommodities = results.map(x => ({ label: x.agentId, value: x.code }));
    } finally {
      loading(false);
    }
  }

  get items() {
    if (this.commodities) return this.commodities;
    return this.$data.localCommodities;
  }
}
